module.exports = __webpack_public_path__ + "static/media/icon.5f5ed669.svg";